import { VContent } from "vuetify/lib";

export default {
	name: "KView",

	computed: {
		loading() {
			return this.$wait.is( "router" ) || !this.$auth.ready();
		}
	},

	render() {

		// For some reason, the empty span tag for the router-view fixes transitions between pages on first page change + fast load
		return <VContent>
			<transition mode="out-in" name="slide-y-transition">
				{this.loading
					? <span></span>
					: <RouterView key={this.$route.name}></RouterView>
				}
			</transition>
		</VContent>;
	}
};
